import React from 'react';
import {
  AboutPospBanner,
  ExplainPosp,
  Faq,
  Partners,
  Payouts,
  PospLeadForm,
  PospDetail,
  RoadMaps,
  aboutPospQuestions,
} from '@prishapolicy/w3/ui';

const AboutOurPosp = () => {
  return (
    <>
      <AboutPospBanner />
      <Partners />
      <ExplainPosp />
      <PospDetail />
      <Payouts />
      <RoadMaps />
      <Faq list={aboutPospQuestions} />
      <PospLeadForm />
    </>
  );
};

export default AboutOurPosp;
